import { getTemplateDrawings } from "@/pages/templates/repositories/TemplatesRepositorie";
import { useTemplatesContext } from "@/pages/templates/context/templatesContext";
import { get } from "lodash-es";

type Props = {
	setIsTemplateDrawingsLoading: (isLoading: boolean) => void;
	setTemplateDrawingsError: (err: string) => void;
	TemplateId: number | null;
};

export const useSearchTemplateDrawings = ({
	setIsTemplateDrawingsLoading,
	setTemplateDrawingsError,
	TemplateId,
}: Props) => {
	const {
		state: {},
		actions: { setTemplateDrawingsList },
	} = useTemplatesContext();

	return async () => {
		setTemplateDrawingsList([]);
		setIsTemplateDrawingsLoading(true);
		const res = await getTemplateDrawings(TemplateId as number);
		if (res.ok) {
			const rowsSource = get(res, "data.tables[0].rows", []);
			setTemplateDrawingsList(rowsSource);
			setIsTemplateDrawingsLoading(false);
		} else {
			setIsTemplateDrawingsLoading(false);
			setTemplateDrawingsError(res.message);
		}
	};
};
